import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LocalStorageService } from './service';

@NgModule({
  imports: [CommonModule]
})
export class SharedLocalStorageModule {
  static forRoot(): ModuleWithProviders<SharedLocalStorageModule> {
    return {
      ngModule: SharedLocalStorageModule,
      providers: [LocalStorageService]
    };
  }
}
